import React from 'react';
const FloatButtonGroupContext = React.createContext(undefined);
export const { Provider: FloatButtonGroupProvider } = FloatButtonGroupContext;
export default FloatButtonGroupContext;
